import { useContext, useEffect, useState } from 'react';

// Contexts
import TennisApiContext from '../contexts/TennisApiContext';

// Types
import { ITennisCompetitionResponseData, ITennisCompetition, ITennisTournament, ITennisSeasonYear } from '../../../../packages/types';

interface IUseCompetitionArgs {
  dataCompetition?: string;
  season?: string;
}
export default function useCompetition({ dataCompetition, season }: IUseCompetitionArgs) {
  const [competition, setCompetition] = useState<ITennisCompetition>();
  const [tournaments, setTournaments] = useState<ITennisTournament[]>();
  const [seasonYears, setSeasonYears] = useState<ITennisSeasonYear[]>();

  const { $tennis } = useContext(TennisApiContext);

  useEffect(() => {
    if (dataCompetition) {
      $tennis
        ?.getCompetition({ dataCompetition, season })
        ?.then(({ competition }: ITennisCompetitionResponseData | any) => {
          setCompetition(competition?.competition);
          setSeasonYears(competition?.availableSeasonYears);
          setTournaments(competition?.tournaments);
        })
        .catch((error: unknown) => {
          console.error(error);
        });
    }
  }, [dataCompetition, season]);

  return {
    seasonYears,
    competition,
    tournaments,
  };
}
